import type {ReactAction} from '@netx/core/bootstrap';
import {faList} from '@netx/core-icons';
import {canEditCurrentCartAttributes} from '../enablers';
import {CART_CURRENT_ACTION_LABELS} from '../locales';
import {CART_CURRENT_EVENT} from './constants';

/**
 * Edit cart asset attribute values
 * @param params
 * @returns Action
 */
export const cartActionEditAttributes = (
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'current-cart-edit-attributes',
	cb: () => dispatcher.trigger(CART_CURRENT_EVENT.EDIT_ATTRIBUTES),
	enableTest: canEditCurrentCartAttributes,
	icon: faList,
	get label() {
		return CART_CURRENT_ACTION_LABELS.EDIT_ATTRIBUTES;
	},
	...params,
});

export default cartActionEditAttributes;
